import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { CommonService } from "src/app/core/services/common.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { AdvancedFiltersService } from "src/app/core/services/advancedFilters.service";
import { PlacaService } from "../../services/placa.service";
import { QueryFilesPlacaService } from "../../services/query-files-placa.service";
import { Placa } from "../../models/placaMailBox";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { TableComponent } from "src/app/shared/table/table.component";
import {
  Options,
  OptionsOutTable,
} from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { AppConstants } from "src/app/constants/app.constants";
import { ExportarExcelMassivoService } from "src/app/core/services/exportarExcelMassivo.service";
import { TokenService } from "src/app/core/services/token.service";

@Component({
  selector: "app-list-query",
  templateUrl: "./list-query.component.html",
  styleUrls: ["./list-query.component.scss"],
})
export class ListQueryComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("outTable") filtersOutTable: FiltersComponent;
  @ViewChild("placa") placa: TableComponent;
  @ViewChild("placaHistory") placaHistory: TableComponent;
  placaList;
  placaHistoryList;
  filtersTable: string;
  filtersTableHistory: string;
  filtersTableJSON;
  filtersTableJSONAux;
  filtersTableHistoryJSON;
  filtersTableHistoryJSONAux;
  filtersSearch = "";
  roles = AppConstants.roles;
  filterList = FilterConstants.placaQuery;
  tableList = TableConstants.placaQuery;
  routingMailBox = RoutingConstants.placaQuery;
  routingHistory = RoutingConstants.placaQueryHistory;
  public optionsMailBox: Options =
    TableConstants.NotShowCreateDeleteAndArrowUpDown;
  public optionsHistory: Options =
    TableConstants.NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel;
  filterListOutTable = FilterConstants.placaOutTable;
  filtersSearchOutTable = "";
  public optionsFiltersOutTable: OptionsOutTable = {
    isOutTable: true,
    showFilters: false,
    style: { "min-width": "1423px" },
    showCheckbox: false,
  };
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  numPagesHistory: number = 0;
  numElementsHistory: number = 0;
  totalElementsHistory: number = 0;
  placaLoaded: boolean = false;
  placaHistoryLoaded: boolean = false;
  showTableFilter = false;
  showFiltersOut: boolean = false;
  showFilterButtons: boolean = false;
  warningShowed = {
    notHistory: false,
    history: false,
  };

  filterTramite = true;
  filterHistorico = true;

  mensajeAvisoExportar: boolean = false;
  userConcesionario: boolean = this.tokenService.hasRole(this.roles.CONCES);

  constructor(
    private placaService: PlacaService,
    private exportarExcelMassivoService: ExportarExcelMassivoService,
    private translateService: TranslateService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private listValueService: ListValueService,
    private sweetAlertService: SweetAlertService,
    private queryFilesPlacaService: QueryFilesPlacaService,
    private tokenService: TokenService,
    private advancedFiltersService: AdvancedFiltersService
  ) {
    this.optionsMailBox.style = { "min-width": "1278px" };
    this.optionsHistory.style = { "min-width": "1278px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "peCreacion",
      ScreenConstants.placa.queryPlaca
    );
    this.filtersTableHistoryJSON =
      this.filtersTableStateService.initFiltersTableHistory(
        "peCreacion",
        ScreenConstants.placa.queryPlacaHistory
      );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersTableHistory = this.filtersTableStateService.getString(
      this.filtersTableHistoryJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
    this.filtersSearchOutTable =
      this.filtersTableStateService.composeFiltersOutTable(
        this.filterListOutTable
      );
  }

  ngOnInit(): void {
    this.getList(this.filtersTable);
    this.getHistoryList(this.filtersTableHistory);
    this.getAnalystList();
    this.getBrandsList();
    this.getTiposdeVehiculoList();
    this.getMotorList();
    this.getTipoPlacaList();
    this.getEstadosList();
    this.getCertificateList();
    this.loadListMotivosReedicion();
  }

  getList(filtersTable: string) {
    let filters = this.commonService.concatThreeFilters(
      filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    this.warningShowed.notHistory = false;
    this.sweetAlertService.sweetAlertLoading();
    this.placaService.getListQuery(filters).subscribe(
      (data) => {
        if (data) {
          this.placaList = data.content.map((e) => Placa.placaFromJson(e));
          this.numPages = data.totalPages == 0 ? 1 : data.totalPages;
          this.numElements = data.numberOfElements;
          this.totalElements = data.totalElements;
          this.placaLoaded = true;
          if (this.placaHistoryLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }

          if (
            data.content &&
            data.content.length == 0 &&
            this.placaHistoryList &&
            this.placaHistoryList.length == 0
          ) {
            this.warningShowed.notHistory = true;
            this.toastrAlertService.showWarning(
              this.warningShowed.history,
              this.warningShowed.notHistory
            );
          }
        } else {
          this.placaList = [];
          this.placaLoaded = true;
          if (this.placaHistoryLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getHistoryList(filtersTableHistory: string) {
    let filters = this.commonService.concatThreeFilters(
      filtersTableHistory,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    this.warningShowed.history = false;
    this.sweetAlertService.sweetAlertLoading();
    this.placaService.getHistorylist(filters).subscribe(
      (data) => {
        if (data) {
          this.placaHistoryList = data.content.map((e) =>
            Placa.placaFromJson(e)
          );
          this.numPagesHistory = data.totalPages == 0 ? 1 : data.totalPages;
          this.numElementsHistory = data.numberOfElements;
          this.totalElementsHistory = data.totalElements;
          this.mensajeAvisoExportar = this.totalElementsHistory > 10000;
          this.placaHistoryLoaded = true;
          if (this.placaLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }

          if (
            data.content &&
            data.content.length == 0 &&
            this.placaList &&
            this.placaList.length == 0
          ) {
            this.warningShowed.history = true;
            this.toastrAlertService.showWarning(
              this.warningShowed.history,
              this.warningShowed.notHistory
            );
          }
        } else {
          this.placaHistoryList = [];
          this.placaHistoryLoaded = true;
          if (this.placaLoaded) {
            this.sweetAlertService.sweetAlertClose();
          }
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getAnalystList() {
    this.listValueService.listaAnalistasBuzon().subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Analista");
        data.sort(function (a, b) {
          if (a.usuarioId.toUpperCase() < b.usuarioId.toUpperCase()) {
            return -1;
          }
          if (a.usuarioId.toUpperCase() > b.usuarioId.toUpperCase()) {
            return 1;
          }
          return 0;
        });
        this.filterList[pos]["selectorConf"].dataList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  getBrandsList() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Marca");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  getTiposdeVehiculoList() {
    this.listValueService.listTipoVehiculo().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo homologado"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  loadListMotivosReedicion() {
    this.listValueService.listMotivosReedicion().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Motivo reedición"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getMotorList() {
    this.listValueService.listMotor().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex((e) => e.label == "Motor");
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getTipoPlacaList() {
    this.listValueService.listTipoPlaca().subscribe(
      (data) => {
        let pos = this.filterListOutTable.findIndex(
          (e) => e.label == "Tipo de placa"
        );
        this.filterListOutTable[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getEstadosList() {
    this.listValueService.listEstadosByScreen("ES_CONS_PLACA").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Estado");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCertificateList() {
    this.listValueService.listCertificates("3", "false").subscribe(
      (data) => {
        let pos = this.filterList.findIndex((e) => e.label == "Tipo solicitud");
        this.filterList[pos]["selectorConf"].dataList = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTableStateService.setFiltersTable(this.filtersTableJSON);
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.getList(this.filtersTable);
  }

  filterTableHistory(value: any) {
    this.filtersTableHistoryJSON = value.filterTableJSON;
    this.filtersTableStateService.setFiltersTableHistory(
      this.filtersTableHistoryJSON
    );
    this.filtersTableHistory = this.filtersTableStateService.getString(
      this.filtersTableHistoryJSON
    );
    this.getHistoryList(this.filtersTableHistory);
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersOutTable.filtersSelectorSearch = [];
        this.filtersOutTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        this.filtersOutTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersSearchOutTable = this.filtersOutTable.composeParams();
        this.filtersTableStateService.setFiltersTable(this.filtersTableJSON);
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.placaLoaded = false;
        this.placaHistoryLoaded = false;
        this.getList(this.filtersTable);
        this.filtersTableStateService.setFiltersTableHistory(
          this.filtersTableHistoryJSON
        );
        this.filtersTableStateService.setPageStateHistory(0);
        this.filtersTableHistoryJSON =
          this.filtersTableStateService.getFiltersTableStateHistory();
        this.filtersTableHistory = this.filtersTableStateService.getString(
          this.filtersTableHistoryJSON
        );
        this.getHistoryList(this.filtersTableHistory);
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          if (!this.showFiltersOut) {
            this.showFilterButtons = false;
          }
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  toggleFilterButtons(item: boolean) {
    this.showFiltersOut = item;
    if (this.showFiltersOut) {
      this.showFilterButtons = true;
    } else if (!this.showTableFilter) {
      this.showFilterButtons = false;
    }
  }

  generatePrintFile() {
    this.sweetAlertService.sweetAlertLoading();
    this.queryFilesPlacaService.getFileGeneration().subscribe(
      (data) => {
        if (data["mensaje"] == "NO FILES") {
          let message = this.translateService.instant(
            "messages.placa.noFilesGenerated"
          );
          this.toastrAlertService.toastrInfo(message);
        } else {
          this.toastrAlertService.toastrSuccess(data["mensaje"]);
        }
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  getFiltersByUser() {
    this.advancedFiltersService.getAdvancedFiltersByUser("PLACA").subscribe(
      (data) => {
        this.filterListOutTable = this.advancedFiltersService.renderFiltersOut(
          data,
          this.filterListOutTable
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }

  public exportToExcel()
  {
    if(this.mensajeAvisoExportar)
    {
      this.toastrAlertService.toastrInfo("Solo se van a exportar los primeros 10.000 registros");
    }
    
    const filters = this.commonService.concatThreeFilters(
      this.filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );

    const cleanFilters = filters.startsWith('?') ? filters.slice(1) : filters;

    const filtros: Record<string, any> = cleanFilters.split('&').reduce((acc, filter) => {
        const [key, value] = filter.split('=');
        acc[key] = decodeURIComponent(value); 
        return acc;
    }, {});

    filtros.page = 0;
    filtros.size = 10000;

    const historyFilters = this.filtersTableHistory.split('&').reduce((acc, filter) => {
        const [key, value] = filter.split('=');
        if (key === 'asc') {
            acc['ascHistory'] = decodeURIComponent(value);
        } else if (key === 'order') {
            acc['orderHistory'] = decodeURIComponent(value);
        }
        return acc;
    }, {});

    Object.assign(filtros, historyFilters);

    this.exportarExcelMassivoService.exportToExcel("placa", filtros);
  }
}
